export const default_display = 'default';
export const notify = 'notify';
export const geoposition = 'geoposition';
